import ProviderAPIClient, { type TrfPdf } from '@/features/auth/ProviderAPIClient'

/**
 * Fetch the DRAFT TRF PDF for an ordering session from provider-api (GEN-4159).
 *
 * The backend renders the TRF server-side, writes ``{session_id}/DRAFT.pdf`` to S3, and streams
 * the bytes back same-origin (JWT-authenticated through provider-api) — never a pre-signed S3 URL
 * the browser must fetch cross-origin. Fetching S3 directly is blocked inside the Epic SMART
 * embedded iframe, so streaming through the API is what makes the DRAFT render there. The bytes
 * are handed to the existing ``PDFViewer`` (pdfjs-dist), so the display flow is unchanged.
 *
 * @param sessionId  Ordering session id (also the S3 key prefix).
 * @param options    ``isEhrOrder`` explicit Epic-SMART launch flag forwarded to the endpoint.
 * @param signal     Abort signal so an in-flight fetch is cancelled on unmount / re-fetch.
 */
export async function fetchDraftTrfPdfBytes(
  sessionId: string,
  options: { isEhrOrder?: boolean } = {},
  signal?: AbortSignal
): Promise<TrfPdf> {
  const client = ProviderAPIClient.getInstance()
  return client.getDraftPdfContent(
    sessionId,
    options.isEhrOrder != null ? { isEhrOrder: options.isEhrOrder } : {},
    signal
  )
}
